if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer") && this.submitButton)
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        // Initialize subscription options if present
        this.subscriptionOptions = document.querySelector(
          "[data-subscription-options]"
        );

        if (this.subscriptionOptions) {
          this.subscriptionInputs = this.subscriptionOptions.querySelectorAll(
            'input[name="subscription"]'
          );
          this.initSubscriptionHandlers();
        }
      }

      initSubscriptionHandlers() {
        if (this.subscriptionInputs) {
          this.subscriptionInputs.forEach((input) => {
            input.addEventListener("change", (event) => {
              // Update UI to show selected subscription
              this.subscriptionInputs.forEach((input) => {
                const label = input.nextElementSibling;
                if (input.checked) {
                  label.classList.add("selected");
                } else {
                  label.classList.remove("selected");
                }
              });
            });
          });
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        // Check if subscription is required but not selected
        if (this.subscriptionOptions) {
          const selectedSubscription = this.subscriptionOptions.querySelector(
            'input[name="subscription"]:checked'
          );
          if (!selectedSubscription) {
            this.handleErrorMessage("Please select a subscription plan");
            return;
          }
        }

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        try {
          const subscriptionResponse = await this.addSubscriptionToCart();
          const productResponse = await this.addProductToCart();

          // Pass both responses to handle success
          this.handleSuccessfulAdd(productResponse || subscriptionResponse);
        } catch (error) {
          console.error("Cart addition error:", error);
          this.handleErrorMessage(error.message);
        } finally {
          this.submitButton.setAttribute("aria-disabled", false);
          this.submitButton.classList.remove("loading");
        }
      }

      async addProductToCart() {
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        return this.addItemToCart(formData);
      }

      async addSubscriptionToCart() {
        // If we have a subscription option selected, add it as well
        if (!this.subscriptionOptions) {
          return {};
        }

        const selectedSubscription = this.subscriptionOptions.querySelector(
          'input[name="subscription"]:checked'
        );
        if (!selectedSubscription) {
          return Promise.reject(new Error("No subscription selected"));
        }

        
        if (
          selectedSubscription.value === "no-subscription" ||
          selectedSubscription.id === "device-only-no-subscription"
        ) {
          return {};
        }

        const subscriptionFormData = new FormData();
        subscriptionFormData.append("id", selectedSubscription.value);
        subscriptionFormData.append("quantity", 1);

        // Add selling plan ID for subscription products
        const sellingPlanId = selectedSubscription.dataset.sellingPlanId;
        if (sellingPlanId) {
          subscriptionFormData.append("selling_plan", sellingPlanId);
        }

        if (this.cart) {
          subscriptionFormData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          subscriptionFormData.append("sections_url", window.location.pathname);
        }

        try {
          const response = await this.addItemToCart(subscriptionFormData);
          return response;
        } catch (error) {
          throw error;
        }
      }

      async addItemToCart(formData) {
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        config.body = formData;

        const response = await fetch(`${routes.cart_add_url}`, config);

        const data = await response.json();

        if (data.status) {
          throw new Error(data.description || "Error adding item to cart");
        }

        return data;
      }

      handleSuccessfulAdd(response) {
        if (!this.error) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: this.form.querySelector("[name=id]").value,
          });
        }

        this.error = false;
        const quickAddModal = this.closest("quick-add-modal");
        if (quickAddModal) {
          document.body.addEventListener(
            "modalClosed",
            () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else if (this.cart) {
          this.cart.renderContents(response);
        } else {
          // Respect store settings for cart behavior
          window.location = window.routes.cart_url;
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
